import { useState } from 'react'
import { AlertTriangle, ChevronDown } from 'lucide-react'
import { RosterList } from './RosterList'
import { asRosterMembers, type ResolvedRecipient } from './useRecipientChips'
import { cn } from '@/lib/utils'

/**
 * "2 left out — no mobile on file", made answerable.
 *
 * The count alone told you something was wrong without telling you what: two
 * people out of a group of forty, and no way to find out which two short of
 * opening Microsoft 365 and reading down the list. Expanding names them, so the
 * gap can be filled before the message goes out rather than discovered after.
 */
export function UnreachableNotice({
  unreachable,
}: {
  unreachable: Array<ResolvedRecipient>
}) {
  const [open, setOpen] = useState(false)

  if (unreachable.length === 0) return null

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 rounded-full border border-warn-border bg-warn-tint px-[11px] py-1 text-[12px] font-bold text-warn-ink transition-opacity hover:opacity-90"
        aria-expanded={open}
      >
        <AlertTriangle className="h-[12px] w-[12px]" />
        {unreachable.length} left out — no mobile on file
        <ChevronDown className={cn('h-3 w-3 transition-transform', open && 'rotate-180')} />
      </button>

      {open && (
        <div className="w-full overflow-hidden rounded-xl border border-warn-border bg-surface">
          <div className="border-b border-border-2 bg-warn-tint px-[13px] py-2 text-[11.5px] font-semibold text-warn-ink">
            These people are in the groups you picked, but no text can reach them. Add a mobile
            number in Microsoft 365 to include them.
          </div>
          <RosterList members={asRosterMembers(unreachable)} />
        </div>
      )}
    </>
  )
}
